var React = require('react');

/**
 * Reusable ChipButton component for displaying selectable chips/buttons
 * @param {string} label - The text to display on the chip
 * @param {function} onClick - Click handler function
 * @param {boolean} isSelected - Whether the chip is selected
 * @param {string} borderColor - Color for the border (default: #4D5674)
 * @param {string} backgroundColor - Background color when selected (default: uses borderColor)
 * @param {string} textColor - Text color when not selected (default: uses borderColor)
 * @param {object} style - Additional inline styles
 * @param {string} className - Additional CSS classes
 */
const ChipButton = ({
  label,
  onClick,
  isSelected = false,
  borderColor = '#4D5674',
  backgroundColor,
  textColor,
  style = {},
  className = '',
}) => {
  const selectedBgColor = backgroundColor || borderColor;
  const unselectedTextColor = textColor || borderColor;

  return (
    <button
      type='button'
      onClick={onClick}
      className={`mr-2 d-flex ${className}`}
      style={{
        border: `1px solid ${borderColor}`,
        borderRadius: '30px',
        height: '32px',
        padding: '6px 16px 7px',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        backgroundColor: isSelected ? selectedBgColor : 'transparent',
        color: isSelected ? 'var(--color-grey-100)' : unselectedTextColor,
        whiteSpace: 'nowrap',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: 600,
        transition: 'all 0.2s ease',
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.target.style.backgroundColor = selectedBgColor;
          e.target.style.color = 'var(--color-grey-100)';
          e.target.style.opacity = '0.8';
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.target.style.backgroundColor = 'transparent';
          e.target.style.color = unselectedTextColor;
          e.target.style.opacity = '1';
        }
      }}
    >
      {label}
    </button>
  );
};

module.exports = ChipButton;
